document.addEventListener("DOMContentLoaded", function () {

$(document).on("click", ".variant-modal__btn--confirm", function(e) {
  e.preventDefault();
  var $btn = $(this);
  if ($btn.hasClass("is-loading")) return; // prevent multiple clicks
  $btn.addClass("is-loading");

  var modal = $btn.closest(".variant-modal");
  
  let messageBox = modal.find(".form-error-jtpl");
if (!messageBox.length) {
  // create a message box if not present
  messageBox = $('<div class="form-error-jtpl"></div>').appendTo(modal.find(".variant-modal__content, .variant-modal__body").first());
}
messageBox.html("").hide();


  var items = [];
  modal.find(".variant-item-wrapper.is-selected").each(function() {
    var variant = $(this).attr("data-variant-id");
    var qty = $(this).find(".quantity__input").val() || 1;
    items.push({ id: variant, quantity: qty });
  });

  // If no variants selected
  if (items.length === 0) {
    messageBox.html("Please select at least one variant!").fadeIn();
    $btn.removeClass("is-loading");
    return false; // stop execution here
  }

  // Proceed if items exist
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify({ items }),
    dataType: 'json',
    contentType: 'application/json',
    success: function(cart) {
      console.log('Items added:', cart);
      $.getJSON('/cart.js', function(cart) {
                        console.log("🛒 Cart item count:", cart.item_count);
                        $('.cart-count').text(cart.item_count); // Update UI
                        $('.cart-count').removeAttr("hidden");
                        $('.cart-count').attr("aria-label", cart.item_count);
                    });
      messageBox.html("Items added successfully!").fadeIn(300).delay(2000).fadeOut(500);

      // close modal safely
      document.activeElement.blur();
      modal.attr("aria-hidden", "true").removeClass("active");
      $("body").removeAttr("modal-show");

      // open cart drawer properly
      const behavior = window.addToCartBehavior || "open_drawer";
      console.log("Add-to-cart action executed with behavior:", behavior);
      if (behavior === "open_drawer") {
    console.log("Condition 1====");
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('cart:open'));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        console.log("🪄 Drawer opened via cart:open event");
      }, 300);
    }else{
      // create custom message HTML
    const msgBox = document.createElement("div");
    msgBox.classList.add("cart-success-msg");
    setTimeout(()=>{
      if( $("body").hasClass("modal-showing")){
        $("body").removeClass("modal-showing");
      }
    },1000)
    setTimeout(() => {
        // document.dispatchEvent(new CustomEvent('cart:open'));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
        console.log("🪄 add items via cart:refresh event");
      }, 300);
    msgBox.innerHTML = `
      
      <div class="msg-text">
        <svg width="40" height="40" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M25.0098 2.51294C37.434 2.51294 47.5098 12.5887 47.5098 25.0129C47.5098 37.4372 37.434 47.5129 25.0098 47.5129C12.5855 47.5129 2.50977 37.4372 2.50977 25.0129C2.50977 12.5887 12.5855 2.51294 25.0098 2.51294ZM20.3374 32.3211L14.8288 26.808C13.8903 25.869 13.8901 24.3377 14.8288 23.3989C15.7677 22.4602 17.3058 22.4661 18.2378 23.3989L22.1213 27.2854L31.7821 17.6246C32.721 16.6857 34.2524 16.6857 35.1911 17.6246C36.1299 18.5632 36.1286 20.096 35.1911 21.0335L23.823 32.4016C22.8855 33.3391 21.3527 33.3405 20.414 32.4016C20.3877 32.3752 20.3622 32.3484 20.3374 32.3211Z" fill="#6E9C1C"/>
        </svg>
        <p>An item has been added to your basket successfully.</p>
      </div>
      <button class="success-modal__close" data-action="close" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M12.9988 13L1 1M1.00128 13L13 1" stroke="#2E2E2E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    `;

    // style it inline (or move to CSS)
    msgBox.style.cssText = `
      position: fixed;
      bottom: 30px;
      right: 0;
      left: 0;
      margin-inline: auto;
      width: fit-content;
      background: #FBFFEE;
      border: .5px solid #6E9C1C;
      color: #03080F;
      padding: 13px 18px;
      border-radius: 8px;
      z-index: 9999;
      display: flex;
      align-items: center;
      gap: 20px;
      animation: fadeIn 0.3s ease;
    `;

    document.body.appendChild(msgBox);

    // close on button click
    msgBox.querySelector(".success-modal__close").addEventListener("click", () => {
      msgBox.remove();
    });

    // auto-remove after 3 sec
    setTimeout(() => {
      msgBox.remove();
    }, 3000);
    }
    },
    error: function(err) {
      console.error('Error adding items:', err);
      messageBox.html("Something went wrong!").fadeIn();
    },
    complete: function() {
      $btn.removeClass("is-loading");
    }
  });

  return false;
});

    // Function to recalculate and update the total price
    function updateTotalPrice() {
        let total_price = 0;

        $(".variant-item-wrapper.is-selected").each(function() {
            const $wrapper = $(this);
            const price = parseFloat($wrapper.data("price"));
            const qty = parseInt($wrapper.find(".quantity__input").val()) || 0;

            if (!isNaN(price) && qty > 0) {
                total_price += price * qty;
            }
        });

        console.log("Total Price:", total_price);
        $(".variant-total__price").text("₹ " + total_price.toFixed(2));
    }

    // Remove existing event listeners to prevent duplicates
    $(".variant-modal__body").off("click", ".variant-modal_add ,.variant-collection_card");
    $(".variant-modal__body").off("click", ".quantity__button");
    $(".variant-modal__body").off("input", ".quantity__input");
    
    // Handle "Add" button click
    $("body").on("click", ".recently-viewed-products .variant-modal__body .variant-modal_add,.variant-modal__body .variant-modal_add ,.variant-modal__body .variant-collection_card", function(e) {
        e.preventDefault();
        e.stopPropagation(); // Prevent event bubbling
        console.log("test========");
        
        const $btn = $(this);
        const $variantWrapper = $btn.closest(".variant-item-wrapper");

        // if ($variantWrapper.length === 0) {
        //     console.warn("No .variant-item-wrapper found!");
        //     return;
        // }
        
        $variantWrapper.addClass("is-selected");
        $variantWrapper.find(".quantity__input").val(1);
        $(".variant-modal__footer .form-error-jtpl").html("");
        
        // Update total price
        updateTotalPrice();
    });

    // Handle quantity change (plus/minus buttons)
    $(document).on("click", ".quantity__button", function(e) {
        e.preventDefault();
        e.stopPropagation(); // Prevent event bubbling
//  console.log($(this));
//  alert("Plus button");
        const $input = $(this).closest(".quantity").find(".quantity__input");
        const $updatequntity = $input.val();
        console.log("$input ",$updatequntity);
        
        $(".variant-modal__footer .form-error-jtpl").html("");
        $(".variant-modal__footer .variant-card-collection").attr("data-quantity", $updatequntity);
        updateTotalPrice();
    });

    // Handle manual quantity input
    $(document).on("input", ".quantity__input", function(e) {
        const qty = parseInt($(this).val()) || 0;
        const $variantWrapper = $(this).closest(".variant-item-wrapper");

        // Update selection state
        if (qty === 0) {
            $variantWrapper.removeClass("is-selected");
        } else {
            $variantWrapper.addClass("is-selected");
        } 
        
        $(".variant-modal__footer .form-error-jtpl").html("");
        updateTotalPrice();
    });

    $("body").on("click", ".selectr-types", function(e){
    e.preventDefault();

    console.log("===== .selectr-types CLICKED =====");

    const target = $(this).attr("data-target");
    console.log("Target modal:", target);

    $(".variant-modal").attr("aria-hidden", "true");
    $(target).attr("aria-hidden", "false");
    $(".form-error-jtpl").html("");
    $(".variant-item-wrapper").removeClass("is-selected");
    $(".variant-total__price").html("₹ 0.00");

    // featured-collection destroy logic
    const featuredCollection = $(this).parents("featured-collection").get(0);
   

    if (featuredCollection && featuredCollection.querySelector(".collection-list-slider")) {
        console.log("Destroying featured-collection slider...");
        requestAnimationFrame(() => {
            if ($(window).width() >= 768) {
                $("featured-collection.swiper-initialized")
                    .removeClass("swiper-backface-hidden")
                    .addClass("swiper-hidden-jtpl");
            } else {
                $("featured-collection.swiper-initialized")
                    .addClass("swiper-hidden-jtpl")
                    .removeClass("swiper-backface-hidden");
            }
            featuredCollection.dispatchEvent(new Event("destroy-slider"));
            
        });
    } else {
        console.warn("No featured-collection slider found for destroy!");
    }

    // recently-viewed-products destroy logic (delay fix)
    const recentlyViewed = document.querySelector("recently-viewed-products");
  
    if (recentlyViewed && recentlyViewed.querySelector(".section--recently-viewed-products")) {
      recentlyViewed.dispatchEvent(new Event("destroy-slider"));
       $("recently-viewed-products .section--recently-viewed-products .products-grid-wrap .products-grid").removeClass("swiper-wrapper")
      setTimeout(() => { // small delay to ensure element ready
        const productSlider = recentlyViewed.querySelector("product-slider");
      
       
       
        //    $("recently-viewed-products .section--recently-viewed-products .products-grid-wrap .products-grid").removeClass("swiper-wrapper")
        $("recently-viewed-products .section--recently-viewed-products .products-grid-wrap").removeClass("swiper-backface-hidden")
      }, 1);
    } 
  
    else{
if (recentlyViewed && recentlyViewed.querySelector(".section--recently-viewed-products")) {
      recentlyViewed.dispatchEvent(new Event("destroy-slider"));
      setTimeout(() => { // small delay to ensure element ready
        const productSlider = recentlyViewed.querySelector("product-slider");
           $("recently-viewed-products .section--recently-viewed-products .products-grid-wrap .products-grid").removeClass("swiper-wrapper")
        $("recently-viewed-products .section--recently-viewed-products .products-grid-wrap").removeClass("swiper-backface-hidden");
        $("recently-viewed-products .section--recently-viewed-products .products-grid-wrap").addClass("f-grid");
      }, 1);
}
    }
  
});

//     $("body").on("click", ".variant-card-collection", function(e){
//         e.preventDefault();
//         var $this = $(this);
//         const $modal = $(this).closest(".variant-modal");
//         const items = [];
        
//         $(".variant-modal__footer .form-error-jtpl").html("");
        
//         $modal.find(".variant-item-wrapper.is-selected").each(function() {
//             const variant = $(this).attr("data-variant-id");
//             const qty = parseInt($(this).find(".quantity__input").val()) || 0;
// console.log(qty);
            

//             if (variant && qty > 0) {
//                 items.push({ "id": variant, "quantity": qty });
//             }
//         });
        
//         if(items.length > 0){
//             $.ajax({
//                 type: 'POST',
//                 url: '/cart/add.js',
//                 data: JSON.stringify({ items: items }),
//                 dataType: 'json',
//                 contentType: 'application/json',
//                 success: function(cart) {
//                     $.getJSON('/cart.js', function(cart) {
//                         console.log("🛒 Cart item count:", cart.item_count);
//                         $('.cart-count').text(cart.item_count); // Update UI
//                         $('.cart-count').removeAttr("hidden");
//                         $('.cart-count').attr("aria-label", cart.item_count);
//                     });
                    
//                     $(".form-error-jtpl").html("Items added successfully!");
//                     $(".variant-modal").attr("aria-hidden", "true");
//                     $("#CartDrawer").attr("open active");
//                     $("body").attr('modal-show');
//                     $(".variant-modal__footer .form-error-jtpl").html("");
                    
//                     // Reinitialize sliders based on parent section
//                     if($this.parents("featured-collection").find(".collection-list-slider").length > 0){
//                         if($(window).width() >= 768){
//                             document.querySelector('featured-collection').dispatchEvent(new Event('init-slider'));
//                             $("featured-collection.swiper-initialized").addClass("swiper-backface-hidden");
//                             $("featured-collection.swiper-initialized").removeClass("swiper-hidden-jtpl");
//                         } else {
//                             $("featured-collection.swiper-initialized").addClass("swiper-backface-hidden");
//                             $("featured-collection.swiper-initialized").removeClass("swiper-hidden-jtpl");
//                         }                     
//                     }
                    
                     
//           const recentlyViewed = document.querySelector("recently-viewed-products");
  
//     if (recentlyViewed && recentlyViewed.querySelector(".section--recently-viewed-products")) {
//       recentlyViewed.dispatchEvent(new Event("init-slider"));
     
//       setTimeout(() => { // small delay to ensure element ready
//         const productSlider = recentlyViewed.querySelector("product-slider");
//         const behavior = window.addToCartBehavior || "open_drawer";
       
       
//         $("recently-viewed-products .section--recently-viewed-products .products-grid-wrap").addClass("swiper-backface-hidden")
//               $("recently-viewed-products .section--recently-viewed-products .products-grid-wrap .products-grid").addClass(" f-grid swipe-mobile__inner ")
//             // $("recently-viewed-products .section--recently-viewed-products .products-grid-wrap .products-grid").addClass("swiper-wrapper")
//             //  $("recently-viewed-products .section--recently-viewed-products .products-grid-wrap .products-grid").removeClass(" f-grid ")
//       }, 2);
//     } 

//                     document.dispatchEvent(
//                         new CustomEvent('cart:updated', {
//                             detail: { cart: cart }
//                         })
//                     );
//                     if (behavior === "open_drawer") {
//                     document.dispatchEvent(new CustomEvent('cart:refresh', {
//                         detail: { open: true }
//                     }));
//                 }else{
//                     document.dispatchEvent(new CustomEvent('cart:refresh', {
//                         detail: { open: false }
//                     }));
//                 }
//                 },  
//                 error: function(err) {
//                     console.error('Error adding items:', err);
//                 }
//             });
//         } else {
//             $(".form-error-jtpl").html("Please select at least one variant!");
//         }
//     });

    $(document).on("click", ".drawer__close-btn", function() {
        console.log("clicked");
        
        // Remove open + active attribute from cart drawer
        $("#CartDrawer").removeAttr("open active");
        
        // Remove modal-show from body
        $("body").removeClass("modal-show");
        
        // (optional) if drawer has an "active" class also
        $("#CartDrawer").removeClass("active");
    });

    $("body").on("click", ".recently-viewed-products .variant-modal__close, .variant-modal__close", function(e) {
        e.preventDefault();
        $(this).parents(".product-card").find(".selectr-types controls").focus();
        console.log("Testt===", $(this).parents(".product-card").find(".selectr-types controls"));
        
        $(".variant-modal").attr("aria-hidden", "true");
        
        // Restore scroll position after a short delay
        const currentScroll = window.scrollY;
        window.scrollTo(0, currentScroll);
        console.log("currentScroll", currentScroll);
        console.log("Scroll after hide:", window.scrollY);
        
        // Reinitialize sliders when modal closes
        if($(this).parents("featured-collection").find(".collection-list-slider").length > 0){
            console.log("featured-collection=====");
            
            if($(window).width() >= 768){
                document.querySelector('featured-collection').dispatchEvent(new Event('init-slider'));
                $("featured-collection.swiper-initialized").addClass("swiper-backface-hidden");
                $("featured-collection.swiper-initialized").removeClass("swiper-hidden-jtpl");
            } else {
                $("featured-collection.swiper-initialized").addClass("swiper-backface-hidden");
                $("featured-collection.swiper-initialized").removeClass("swiper-hidden-jtpl");
            }   
            
            $(this).parents(".product-card").find(".selectr-types controls").focus();
            const currentScroll = window.scrollY;
            window.scrollTo(0, currentScroll);
            console.log("currentScroll", currentScroll);
            console.log("Scroll after hide:", window.scrollY);
        } 
        
          const recentlyViewed = document.querySelector("recently-viewed-products");
  
    if (recentlyViewed && recentlyViewed.querySelector(".section--recently-viewed-products")) {
      recentlyViewed.dispatchEvent(new Event("init-slider"));
     
        $("recently-viewed-products .section--recently-viewed-products .products-grid-wrap").addClass("swiper-backface-hidden")
            $("recently-viewed-products .section--recently-viewed-products .products-grid-wrap .products-grid").addClass("swiper-wrapper")
      setTimeout(() => { // small delay to ensure element ready
        const productSlider = recentlyViewed.querySelector("product-slider");
      
       
       
        $("recently-viewed-products .section--recently-viewed-products .products-grid-wrap").addClass("swiper-backface-hidden")
            $("recently-viewed-products .section--recently-viewed-products .products-grid-wrap .products-grid").addClass(" f-grid swipe-mobile__inner ")
            //  $("recently-viewed-products .section--recently-viewed-products .products-grid-wrap .products-grid").removeClass(" f-grid ")
      }, 2);
    } 
});
})